import youtube from '../../assets/app-logos/youtube.svg';
import soundcloud from '../../assets/app-logos/soundcloud.svg';
import twitch from '../../assets/app-logos/twitch.svg';
import spotify from '../../assets/app-logos/spotify.svg';
import vlc from '../../assets/app-logos/vlc.svg';
import kodi from '../../assets/app-logos/kodi.svg';
import tv360 from '../../assets/app-logos/tv360.svg';
import premierSports from '../../assets/app-logos/premier-sports.svg';
import fptPlay from '../../assets/app-logos/fpt-play.png';
import player8kPrime from '../../assets/app-logos/8k-player-prime.png';
import rugbyPass from '../../assets/app-logos/rugbypass-tv.png';
import watchNrl from '../../assets/app-logos/watchnrl.webp';
import watchAfl from '../../assets/app-logos/watchafl.webp';

const apps = [
  { id: 'youtube', src: youtube, names: ['youtube'], packages: ['com.google.android.youtube', 'com.google.android.youtube.tv'] },
  { id: 'soundcloud', src: soundcloud, names: ['soundcloud'], packages: ['com.soundcloud.android'] },
  { id: 'twitch', src: twitch, names: ['twitch'], packages: ['tv.twitch.android.app', 'tv.twitch.android.viewer'] },
  { id: 'spotify', src: spotify, names: ['spotify'], packages: ['com.spotify.music', 'com.spotify.tv.android'] },
  { id: 'vlc', src: vlc, names: ['vlc', 'vlc for android'], packages: ['org.videolan.vlc'] },
  { id: 'kodi', src: kodi, names: ['kodi'], packages: ['org.xbmc.kodi'] },
  { id: 'tv360', src: tv360, names: ['tv360', 'tv360 smarttv'], packages: ['com.viettel.tv360', 'com.viettel.tv360.tv'] },
  { id: 'premier-sports', src: premierSports, names: ['premier sports', 'premier sports asia'],
    packages: ['premierplayer.premiersports.com.premiersportsasia', 'premierplayer.premiersports.com.premierplayer'] },
  { id: 'fpt-play', src: fptPlay, names: ['fpt play'], packages: ['net.fptplay.ottbox', 'com.fplay.activity'] },
  { id: '8k-player-prime', src: player8kPrime, names: ['8k player prime'], packages: ['shtv.shadeed.player8kprime'] },
  { id: 'rugbypass', src: rugbyPass, names: ['rugbypass', 'rugbypass tv'], packages: ['com.worldrugbypass.app'] },
  { id: 'watchnrl', src: watchNrl, names: ['watchnrl', 'watch nrl'], packages: ['au.com.foxsports.watchnrl'] },
  { id: 'watchafl', src: watchAfl, names: ['watchafl', 'watch afl'], packages: ['au.com.foxsports.watchafl'] },
];

export function previewAppLogo(activity) {
  if (!activity?.fresh || !activity.known || activity.home || activity.inputSelector || activity.generic || activity.isSuitestream) return null;
  const packageName = String(activity.packageName || '').trim().toLowerCase();
  const appName = String(activity.appName || '').trim().toLowerCase();
  // A real package identity takes precedence over a potentially misleading label.
  // Label matching is exact and is used only when the device supplies no package.
  return apps.find((app) => packageName ? app.packages.includes(packageName) : app.names.includes(appName)) || null;
}
